import styled from "styled-components";
import { Button } from "antd";

export const StyledButton = styled(Button)`
  && {
    &.custom {
      width: 100%;
      max-width: ${({ theme }) => theme?.buttons?.submit?.width};
      font-style: normal;
      font-weight: ${({ theme }) => theme?.buttons?.submit?.weight};
      height: ${({ theme }) => theme?.buttons?.submit?.height};
      font-size: ${({ theme }) => theme?.buttons?.submit?.fontSize};
      line-height: ${({ theme }) => theme?.buttons?.submit?.lineHeight};
      padding: ${({ theme }) => theme?.buttons?.submit?.padding};
      text-transform: capitalize;
      color: ${({ theme }) => theme?.buttons?.submit?.color};
      background: ${({ theme }) => theme?.buttons?.submit?.background};
      border-radius: ${({ theme }) => theme?.buttons?.submit?.radius};
      border: none;
      box-shadow: ${({ theme }) => theme?.buttons?.submit?.shadow};

      &:hover {
        background: ${({ theme }) => theme?.buttons?.submit?.hover?.background};
        color: ${({ theme }) => theme?.buttons?.submit?.hover?.color};
      }
    }
  }

  @media (max-width: 767px) {
    && {
      &.custom {
        max-width: 100%;
      }
    }
  }
`;
